import React from 'react';
const Painters = () => <div className="service-page"><h1>Painters</h1><p>Professional painting services for homes and offices.</p></div>;
export default Painters;
